<script setup>
import { defineEmits } from 'vue'
import { CheckCircleIcon, XCircleIcon } from '@heroicons/vue/24/solid'

const props = defineProps({
  title: { default: 'Continue' },
  cancel: { default: 'Cancel' },
  hideCancel: { default: true },
  disableTitle: { type: Boolean, required: false, default: false },
  disabled: { type: Boolean, required: false, default: false },
  processing: { type: Boolean, required: false, default: false },
  processingTitle: { type: String, required: false, default: 'Saving...' },
})

const emit = defineEmits(['save', 'cancel'])

const emitSave = () => {
  if (props.disabled || props.processing) {
    return
  }

  emit('save')
}

const emitCancel = () => {
  if (props.processing) {
    return
  }

  emit('cancel')
}
</script>
<template>
  <div class="inline flex gap-2">
    <button class="btn save" :class="{ 'opacity-70': props.disabled && !props.processing }" :disabled="props.disabled || props.processing" @click.prevent="emitSave">
      <span v-if="props.processing" class="inline-flex items-center gap-2">
        <span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white"></span>
        <template v-if="!disableTitle">{{ props.processingTitle }}</template>
      </span>
      <template v-else>
        <CheckCircleIcon class="icon" />
        <template v-if="!disableTitle">{{ props.title }}</template>
      </template>
    </button>
    <button class="btn cancel" :disabled="props.processing" @click.prevent="emitCancel" v-if="!props.hideCancel">
      <XCircleIcon class="icon" />
      {{ props.cancel }}
    </button>
  </div>
</template>
